import { useQuery } from 'react-query';

import getCountries from '@/common/api/countries/getCountries';
import { ENDPOINT_COUNTRIES } from '@/common/constants';

const useCountries = ({ shippingAvailable }) => {
  const queryKey = [ENDPOINT_COUNTRIES, shippingAvailable];

  return useQuery(queryKey, getCountries);
};

export default useCountries;
